import styled from "@emotion/styled";
import { layers, space } from "@smartsheet/design-tokens";
export const ToasterStyled = styled("div")`
    position: fixed;
    top: ${space.space50};
    left: 0;
    right: 0;

    z-index: ${layers.toast};
`;
//# sourceMappingURL=ToasterStyled.js.map